import { faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import { ListarEtapasPorTipoCasoController } from "../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { Spinner } from "../../../../Loding/SpinnerPadrao";

import {
    DesvincularDocumentoPorEtapaController,
    ListarTiposDeDocumentoController,
    ListartiposdocumentoetapatipocasoecategoriaatendimentoController,
    VincularDocumentoPorEtapaController,
} from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumentoPorEtapa/TipoDocumentoPorEtapa";
import { ListarModulosdoUsuarioController } from "../../../../../Controllers/Users/UsersController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IVincularTiposDocumentoPorEtapa } from "../../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumentoPorEtapa/TipoDocumentoPorEtapa";
import UnForm from "../../../../Form";
import Table from "../../../../Table";
import { useState } from "react";
import usePaginationFilter from "../../../../../hooks/usePaginationFilter";
import OrSpinner from "../../../../Utils/OrSpinner";

interface IVincularDocumento {
    ID_TIPO_DOCUMENTO: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO: number;
}

export default function TipoDocumentoPorEtapa() {
    const [idModulo, setIdModulo] = useState(0);
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });

    const { value: listarCategorias } = useAsyncEffect(
        () => ListarEtapasPorTipoCasoController(idModulo),
        [idModulo, PageFilter.page]
    );

    const {
        execute: listarDocumentosEtapa,
        value: listarTiposDocumentos,
        loading: listarTiposDocumentosLoading,
    } = useAsyncEffect(
        () =>
            ListartiposdocumentoetapatipocasoecategoriaatendimentoController(),
        []
    );

    const { execute: vincularDocumento, loading: vincularDocumentoLoading } =
        useAsyncCallback(VincularDocumentoPorEtapaController, []);

    const handleTipoCanalAtendimentoFormSubmit = (
        formData: IVincularDocumento
    ) => {
        vincularDocumento({ ...formData, ID_TIPO_CASO: idModulo }).then(() => {
            updateListaTipoCanalAtendimento();
        });
    };

    function updateListaTipoCanalAtendimento() {
        listarDocumentosEtapa();
    }
    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_TIPO_DOCUMENTO",
            text: "Tipos de Documento",
            formatter: rowTipoDocumentoEtapa,
            sort: true,
        },
        {
            dataField: "DS_MODULO",
            text: "Categoria Atendimento",
        },
        {
            dataField: "button",
            text: "Deletar",
            isDummyField: true,
            formatter: (_, row) => (
                <div>
                    <div>
                        {
                            <button
                                className="btn btn-sm btn-outline-danger font-weight-bold"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este tipo de Documento por Etapa?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DesvincularDocumentoPorEtapaController(
                                                row.ID_TIPO_DOCUMENTO_ETAPA_TIPO_CASO ??
                                                    0
                                            ).then(() => {
                                                updateListaTipoCanalAtendimento();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </button>
                        }
                    </div>
                </div>
            ),
        },
    ];

    function rowTipoDocumentoEtapa(
        cell: string,
        row: IVincularTiposDocumentoPorEtapa
    ) {
        return (
            <div className="rowCapys d-flex justify-content-between align-items-center">
                <div>
                    <label className="mb-1">{row.DS_TIPO_DOCUMENTO}</label>

                    <div>
                        {row.DS_MODULO && (
                            <>
                                <span
                                    className={`label abel-pill label-inline label-primary`}
                                >
                                    {row.ID_ETAPA_TIPO_CASO} {"-"}{" "}
                                    {row.DS_ETAPA}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <h5 className="text-center">
                        CADASTRO DE TIPO DE DOCUMENTO POR ETAPA
                    </h5>
                    <UnForm handleSubmit={handleTipoCanalAtendimentoFormSubmit}>
                        <div className="row mb-5 mt-5 d-flex justify-content-between">
                            <div className="col-4">
                                <UnForm.LazySelect
                                    name="ID_TIPO_DOCUMENTO"
                                    required
                                    label="Tipo de Documento"
                                    controller={
                                        ListarTiposDeDocumentoController
                                    }
                                    getDS={(e) => e.DS_TIPO_DOCUMENTO}
                                    getKeyValue={(e) => e.ID_TIPO_DOCUMENTO}
                                >
                                    <option />
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-4 ">
                                <UnForm.LazySelect
                                    name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                    label="Categoria de Atendimento"
                                    required
                                    controller={
                                        ListarModulosdoUsuarioController
                                    }
                                    onChange={(e) =>
                                        setIdModulo(Number(e.target.value))
                                    }
                                    getDS={(e) => e.DS_MODULO}
                                    getKeyValue={(e) => e.ID_MODULO}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>

                            <div className="col-4">
                                <UnForm.Select
                                    name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                    required
                                    label="Etapa"
                                    wrapperClassName="col-6"
                                >
                                    <option></option>
                                    {listarCategorias?.map((categoria) => (
                                        <option
                                            value={
                                                categoria.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                        >
                                            Etapa:{" "}
                                            {
                                                categoria.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }{" "}
                                            - {""}
                                            {
                                                categoria.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                        </option>
                                    ))}
                                </UnForm.Select>
                            </div>

                            <div className="col-12 d-flex justify-content-center align-items-end mt-3">
                                <button
                                    className="btn btn-outline-success font-weight-bold col-6 g-2 "
                                    type="submit"
                                    disabled={vincularDocumentoLoading}
                                >
                                    {vincularDocumentoLoading ? (
                                        <span className="d-flex align-items-center justify-content-center ">
                                            Salvar <Spinner size="sm" />
                                        </span>
                                    ) : (
                                        <span className="d-flex align-items-center  justify-content-center g-2">
                                            Salvar{" "}
                                            <FontAwesomeIcon
                                                size="sm"
                                                icon={faSave}
                                            />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                        <hr />
                    </UnForm>
                </div>

                <div className="col-12 mt-5">
                    <OrSpinner
                        loading={listarTiposDocumentosLoading}
                        spinner="capys"
                    >
                        <Table
                            keyField="ID_TIPO_DOCUMENTO_ETAPA_TIPO_CASO"
                            columns={columns}
                            data={listarTiposDocumentos ?? []}
                            sizePerPage={10}
                            loading={listarTiposDocumentosLoading}
                            noDataIndication={
                                <div className="text-center text-muted">
                                    Nenhuma etapa
                                </div>
                            }
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            wrapperClasses="wrapperTable mw-100 x-scroll"
                            classes="tableClasses"
                            bordered={false}
                            defaultStyle={{ classes: "p-3" }}
                            center
                        />
                    </OrSpinner>
                </div>
            </div>
        </>
    );
}
